<template>
<section id="contents" class="page_mypage">
	<div id="title_block">
		<h1 class="title_text">アカウント情報</h1>
		<p class="btn_back"><a href="javascript:history.back();">戻る</a></p>
	</div>
	<div class="contents_inner">
		<p class="read_text">DroneAgentが提供するサービスのアカウント情報です</p>
		<h3>登録情報</h3>
    <profile></profile>
    <h3>パスワードを変更する</h3>
    <password></password>
  </div>
</section>
</template>

<script>
import Vue from 'vue'
import Profile from './Profile'
import ChangePassword from './ChangePassword'
import Logout from './Logout'
import Withdraw from './Withdraw'
Vue.component('profile', Profile)
Vue.component('password', ChangePassword)
Vue.component('logout', Logout)
Vue.component('withdraw', Withdraw)

export default {
  name: 'Home',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
  @import '../assets/css/user.css'
</style>



// WEBPACK FOOTER //
// src/components/Home.vue